"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.partialApply = void 0;
/**
 * Achieve partial application by applying a number of leading arguments to a function and receive a function that expects the remaining
 * arguments.
 *
 * @example
 * ```typescript
 * const add = (a: number, b: number) => a + b;
 * const add1 = partialApply(add, 1);
 * add1(2);
 * // => 3
 * ```
 */
function partialApply(fn, ...head) {
    return (...tail) => fn(...head, ...tail);
}
exports.partialApply = partialApply;
//# sourceMappingURL=partial-apply.js.map